import { render, staticRenderFns } from "./ArchiveDialog.vue?vue&type=template&id=782117ce&scoped=true&"
import script from "./ArchiveDialog.vue?vue&type=script&lang=js&"
export * from "./ArchiveDialog.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveDialog.vue?vue&type=style&index=0&id=782117ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782117ce",
  null
  
)

export default component.exports